import FileExtIcon from '@core/components/ApplyDialogV2/assets/FileExtIcon'
import React, { type FC } from 'react'
import './FileUploaderV2ListItem.scss'
import TrashIcon from '@core/components/ApplyDialogV2/assets/TrashIcon'

const baseClass = 'FileUploaderV2ListItem'

interface FileUploaderV2ListItemProps {
    className?: string
    file: File
    progress?: number
    status?: 'uploading' | 'success' | 'default' | 'error'
    fileError?: string
}

const FileUploaderV2ListItem: FC<FileUploaderV2ListItemProps> = ({
    file,
    progress = 0,
    status = 'default',
    fileError,
}) => {
    if (!file) {
        return null
    }

    const { name, size, lastModified } = file
    const fileSizeKB = size ? (size / 1024).toFixed(0) : '0'

    const formattedDate = lastModified
        ? new Date(lastModified).toLocaleDateString('en-GB', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
          })
        : ''

    const renderContent = () => {
        if (fileError) {
            return (
                <>
                    <div className={`${baseClass} ${baseClass}__file-info ${baseClass}__file-info--error`}>
                        <FileExtIcon className={`${baseClass}__icon ${baseClass}__icon--error`} />
                        <div className={`${baseClass}__details`}>
                            <span className={`${baseClass}__file-name`}>{name}</span>
                            <span className={`${baseClass}__error-message`}>
                                Error uploading the file. Please try again.
                            </span>
                        </div>
                    </div>
                    <button className={`${baseClass}__delete-button`} aria-label="Delete file">
                        <TrashIcon />
                    </button>
                </>
            )
        }
        switch (status) {
            case 'uploading':
                return (
                    <>
                        <div className={`${baseClass} ${baseClass}__file-info`}>
                            <FileExtIcon className={`${baseClass}__icon`} />
                            <span className={`${baseClass}__file-name`}>Attaching '{name}'</span>
                        </div>
                        <div className={`${baseClass}__progress-container`}>
                            <div className={`${baseClass}__progress-bar`} style={{ width: `${progress}%` }}></div>
                        </div>
                        <span className={`${baseClass}__progress-text`}>{progress}%</span>
                    </>
                )
            case 'success':
                return (
                    <>
                        <div className={`${baseClass} ${baseClass}__file-info`}>
                            <FileExtIcon className={`${baseClass}__icon`} />
                            <div className={`${baseClass}__details`}>
                                <span className={`${baseClass}__file-name`}>{name}</span>
                                <span className={`${baseClass}__file-meta`}>
                                    {formattedDate}, {fileSizeKB} KB
                                </span>
                            </div>
                        </div>
                        <button className={`${baseClass}__delete-button`} aria-label="Delete file">
                            <TrashIcon />
                        </button>
                    </>
                )
            // case 'error':
            //     return (
            //         <>
            //             <div className={`${baseClass}__file-info ${baseClass}__file-info--error`}>
            //                 <ErrorIcon className={`${baseClass}__icon ${baseClass}__icon--error`} />
            //                 <div className={`${baseClass}__details`}>
            //                     <span className={`${baseClass}__file-name`}>{name}</span>
            //                     <span className={`${baseClass}__error-message`}>
            //                         Error uploading the file. Please try again.
            //                     </span>
            //                 </div>
            //             </div>
            //             <button className={`${baseClass}__delete-button`} aria-label="Delete file">
            //                 <TrashIcon />
            //             </button>
            //         </>
            //     )
            default:
                return (
                    <div className={`${baseClass} ${baseClass}__default-state`}>
                        <FileExtIcon className={`${baseClass}__icon`} />
                        <span className={`${baseClass}__file-name`}>{name}</span>
                        <span className={`${baseClass}__file-meta`}>
                            {formattedDate}, {fileSizeKB} KB
                        </span>
                        <button className={`${baseClass}__delete-button`} aria-label="Delete file">
                            <TrashIcon />
                        </button>
                    </div>
                )
        }
    }

    return <div className={`${baseClass} ${baseClass}--${status}`}>{renderContent()}</div>
}

export default FileUploaderV2ListItem
